import React, { FC } from 'react';

import { Box } from '@mui/material';

import BundleCourseCard from '../bundleCourseCard';

import BundleCourseItemContentSkeleton from './bundleCourseItemContentSkeleton/BundleCourseItemSkeleton';
import BundleCourseItemModal from './bundleCourseItemModal';

import ResultPanelEmptyData from '@components/store/data-display/resultPanel/resultPanelEmptyData';
import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import useBundleCourseItemsModal from '@hooks/bundle/useBundleCourseItemsModal';
import useDialogWithoutUI from '@hooks/useDialog';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleCourseItemsProps = {
  bundleDetailSeo: BundleEntity;
};

const BundleCourseItems: FC<BundleCourseItemsProps> = ({ bundleDetailSeo }) => {
  const { bundleCourses, isBundleCoursesLoading } = useBundleCourseItem();
  const courseDialog = useDialogWithoutUI({});

  const { setCurrentCourseIndex, setCurrentIndex, currentIndex, handleFetchCourse } = useBundleCourseItemsModal();

  if (isBundleCoursesLoading) {
    return <BundleCourseItemContentSkeleton />;
  }

  if (bundleCourses.length === 0) {
    return <ResultPanelEmptyData sx={{ height: 264 }} />;
  }

  const onClickCourseCard = (courseIdName: string) => {
    setCurrentCourseIndex(courseIdName);
    handleFetchCourse(courseIdName);
    courseDialog.onOpen();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 0, md: 2 },
      }}
    >
      {bundleCourses.map((course) => (
        <Box
          key={course.id}
          sx={{
            cursor: 'pointer',
          }}
          onClick={() => onClickCourseCard(course.idName)}
        >
          <BundleCourseCard
            courseName={course.name}
            courseImage={course.highlightImage1xUrl}
            courseNo={course.sortOrder}
            hasCertificate={course.hasCertificate}
            countdownDay={course.countdownDay}
            isEnrolled={course.isEnrolled}
            instructors={course.instructors}
          />
        </Box>
      ))}
      <BundleCourseItemModal
        open={courseDialog.isOpened}
        onClose={courseDialog.onClose}
        bundleDetailSeo={bundleDetailSeo}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
    </Box>
  );
};

export default BundleCourseItems;
